export default __webpack_public_path__ + "static/media/envelope.89f2ec82.svg";